// @ts-nocheck
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  if (config.public.stage === 'local') { return }
  const clientId = config.public.stage === 'live' ? '9be86213bc1d4b28f4afe046' : '71f349d639b3e22a5afad818'
  window.dataLayer = window.dataLayer || []
  function gtag () {
    dataLayer.push(arguments)
  }
  gtag('consent', 'default', {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    analytics_storage: 'granted',
    functionality_storage: 'granted',
    personalization_storage: 'granted',
    security_storage: 'granted',
    wait_for_update: 0
  })
  gtag('set', 'ads_data_redaction', false)

  useHead({
    script: [
      {
        src: `//cdn-cookieyes.com/client_data/${clientId}/script.js`,
        async: true,
        type: 'text/javascript'
      }
    ]
  })
})
